import { useEffect, useRef, useState } from "react";
import { useSelector, useDispatch } from "react-redux";

import { getInjury } from "../state/injuries/actions";
import { useAppInsights } from "../utils/telemetry/AppInsights";

const useInjuries = (caseId, injuryId, enabled = true) => {
  const { trackException } = useAppInsights();
  const [initialized, setInitialized] = useState(false);
  const dispatch = useDispatch();
  const injuries = useSelector(state => state.injuries);
  const attemptedInjuryId = useRef(null);

  const loadedInjuryId = injuries.data && injuries.data.id;

  useEffect(() => {
    if (!enabled) return;

    if (loadedInjuryId === injuryId) {
      setInitialized(true);
      return;
    }

    if (attemptedInjuryId.current === injuryId) return;
    attemptedInjuryId.current = injuryId;
    setInitialized(false);

    dispatch(
      getInjury({
        caseId,
        injuryId,
        onFinish: success => {
          if (!success) {
            trackException(
              `Failed to get injury data from: ${injuryId} at case: ${caseId}`
            );
          }
          setInitialized(true);
        }
      })
    );
  }, [caseId, dispatch, enabled, injuryId, loadedInjuryId, trackException]);

  return { ...injuries, initialized };
};

export default useInjuries;
